<template>
<div class="chapter">
<div class="inner_page">
<p class="praise"><a href="#/OEBPS/toc.htm#pra"><strong>Praise for Val McDermid’s Lindsay Gordon series</strong></a></p>
<p class="extract">“Her real skills in creating compelling characters, as well as a mystery that is profoundly twisted and filled with enough legitimate red herrings to stock Fisherman’s Wharf, blossom in this dark, chilling novel.”</p>
<p class="right"><em>—Bay Area Reporter</em> on <em>Final Edition</em></p>
<p class="extract">“Val McDermid is an inspiration.”</p>
<p class="right"><em>—Herald</em> (Scotland) on <em>Common Murder</em></p>
<p class="extract">“Tough, exciting, moody, and unpredictable.”</p>
<p class="right"><em>—Times</em> (UK) on <em>Union Jack</em></p>
<p class="extract">“McDermid’s snappy, often comic prose keeps the story humming.”</p>
<p class="right"><em>—Publishers Weekly</em> on <em>Common Murder</em></p>
<p class="extract">“The macho world of the whodunnit has never seen a sleuth like Lindsay Gordon.”</p>
<p class="right"><em>—Manchester Evening News</em> (UK) on <em>Booked for Murder</em></p>
<p class="extract">“Full marks for plot, atmosphere, character, dialogue, politics, humour—Oh hell, full marks for just about everything. I don’t know how Val does it, but I’m bloody glad she does.”</p>
<p class="right"><em>—Crime Time</em> on <em>Booked for Murder</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pra.vue?ae5a6cc2